import { OIDC_SESSION_PREFIX } from './storageKeys';

const providers = new Map([
    [
        'appcentral',
        {
            matches: ({ key }) => key.startsWith(OIDC_SESSION_PREFIX),
            normalize: ({ rawValue }) => {
                try {
                    const parsed = JSON.parse(rawValue);
                    if (!parsed?.profile?.preferred_username || !parsed?.access_token) {
                        return null;
                    }

                    return {
                        authMethod: 'sso',
                        preferred_username: parsed.profile.preferred_username,
                        coid: parsed.profile.coid,
                        uoid: parsed.profile.uoid,
                        authToken: parsed.access_token
                    };
                } catch (error) {
                    return null;
                }
            }
        }
    ]
]);

// Dynamic provider registration is intentionally disabled for now.
export const registerSsoProvider = () => false;

export const resolveSsoPayload = (sessionStorageRef) => {
    if (!sessionStorageRef) {
        return null;
    }

    const keys = Object.keys(sessionStorageRef);
    for (let index = 0; index < keys.length; index += 1) {
        const key = keys[index];
        const rawValue = sessionStorageRef[key];

        const providerEntries = Array.from(providers.entries());
        for (let providerIndex = 0; providerIndex < providerEntries.length; providerIndex += 1) {
            const [providerId, adapter] = providerEntries[providerIndex];
            if (!adapter.matches({ key, rawValue })) {
                continue;
            }

            const normalized = adapter.normalize({ key, rawValue });
            if (normalized) {
                return {
                    providerId,
                    ...normalized
                };
            }
        }
    }

    return null;
};
